<template lang="pug">
  div.welfare-header-container(:style="headerBgStyle")
    .bounty-notice
      BountyNotice(:styleVersion="styleVersion" :noticeData="noticeData")
    //- 积分信息
    PointsInfo(
      :points="points"
      :bounty="bounty"
      :bountyLoaded="bountyLoaded"
      @pointsClick="handlePointsClick"
    )
      template(slot='right')
        HeaderBubbles(
          :rewardCount="rewardCount"
          :isDueSoon="isDueSoon"
          :pureVersion="pureVersion"
          @awardClick="handleAwardClick"
        )

    //- 兑换商品
    CommonLoadBox(v-if="!pureVersion" :loaded="goodsCateInfo.loaded")
      template(slot='skeleton')
        .exchange-goods-skeleton-area
          ExchangeGoodsSkeleton
      template(slot='module')
        ExchangeGoods(
          v-if="exchangeGoodsList.length > 0"
          :points="points"
          :exchangeGoodsList="exchangeGoodsList"
          :rewardGuidingRules="rewardGuidingRules"
          :goodsCateInfo="goodsCateInfo"
          @bounty="$emit('bounty')"
        )
</template>

<script>
import CommonLoadBox from '@/components/common-load-box';
import PointsInfo from './points-info';
import ExchangeGoods from './exchange-goods';
import HeaderBubbles from './header-bubbles';
import BountyNotice from '../components/bounty-notice';
import ExchangeGoodsSkeleton from '../skeleton-cpns/exchange-goods-skeleton';
import { TOP_HEADER_BG_IMGS } from '../consts';

export default {
  name: 'WelfareHeader',
  components: {
    PointsInfo,
    ExchangeGoods,
    HeaderBubbles,
    CommonLoadBox,
    ExchangeGoodsSkeleton,
    BountyNotice,
  },
  props: {
    points: {
      type: Number,
      default: 0,
    },
    bounty: {
      type: Number,
      default: 0,
    },
    // 兑换商品列表
    exchangeGoodsList: {
      type: Array,
      default: () => [],
    },
    // 奖励引导规则
    rewardGuidingRules: {
      type: Array,
      default: () => [],
    },
    // 单单返币奖励金数量
    rewardCount: {
      type: Number,
      default: 0,
    },
    // 单单返奖励金是否即将过期
    isDueSoon: {
      type: Boolean,
      default: false,
    },
    // 新人引导兑换商品类目信息
    goodsCateInfo: {
      type: Object,
      default: () => {},
    },
    // 奖励金加载状态
    bountyLoaded: {
      type: Boolean,
      default: false,
    },
    styleVersion: {
      type: String,
      default: '',
    },
    // 公告数据透传
    noticeData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  inject: ['isPureVersion'],
  computed: {
    headerBgStyle() {
      const noGoods = this.goodsCateInfo.loaded && this.exchangeGoodsList.length === 0;
      const imageUrl = noGoods ? TOP_HEADER_BG_IMGS[1] : TOP_HEADER_BG_IMGS[0];
      if (this.pureVersion) {
        return {
          backgroundImage: `url(${TOP_HEADER_BG_IMGS[1]})`,
        };
      }
      return {
        backgroundImage: `url(${imageUrl})`,
      };
    },
    // 是否是纯净版页面
    pureVersion() {
      return this.isPureVersion();
    },
  },
  mounted() {},
  methods: {
    // 点击积分
    handlePointsClick() {
      this.$emit('pointsClick');
    },
    // 点击单单返奖励
    handleAwardClick() {
      this.$emit('awardClick');
    },
  },
};
</script>

<style lang="less" scoped>
.welfare-header-container {
  padding: 0.85rem 0 0.63rem;
  margin-bottom: -0.54rem;
  width: 100%;
  background-color: #2670e9;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .exchange-goods-skeleton-area {
    margin-top: 0.12rem;
    padding: 0 0.08rem;
  }

  .bounty-notice {
    padding: 0.02rem 0 0.14rem;
  }
}
</style>
